export * from "./html-config.view";
